module.exports = __webpack_public_path__ + "img/Centro-Picasso-200x91.7644ead6.png";